/** Accent tokens for frontpage tiles. Legacy Tailwind gradient strings map to these. */

export const FRONTPAGE_COLORS = [
  { id: 'sky', labelKey: 'ui.colorSky' },
  { id: 'teal', labelKey: 'ui.colorTeal' },
  { id: 'violet', labelKey: 'ui.colorViolet' },
  { id: 'rose', labelKey: 'ui.colorRose' },
  { id: 'green', labelKey: 'ui.colorGreen' },
  { id: 'orange', labelKey: 'ui.colorOrange' },
  { id: 'indigo', labelKey: 'ui.colorIndigo' },
  { id: 'emerald', labelKey: 'ui.colorEmerald' },
  { id: 'blue', labelKey: 'ui.colorBlue' },
  { id: 'amber', labelKey: 'ui.colorAmber' },
  { id: 'red', labelKey: 'ui.colorRed' },
  { id: 'gray', labelKey: 'ui.colorGray' },
]

const LEGACY_COLOR_MAP = {
  'from-sky-900/80 to-sky-950/80': 'sky',
  'from-teal-900/80 to-teal-950/80': 'teal',
  'from-violet-900/80 to-violet-950/80': 'violet',
  'from-rose-900/80 to-rose-950/80': 'rose',
  'from-green-900/80 to-green-950/80': 'green',
  'from-orange-900/80 to-orange-950/80': 'orange',
  'from-indigo-900/80 to-indigo-950/80': 'indigo',
  'from-emerald-900/80 to-emerald-950/80': 'emerald',
  'from-blue-900/80 to-blue-950/80': 'blue',
  'from-amber-900/80 to-amber-950/80': 'amber',
  'from-red-900/80 to-red-950/80': 'red',
  'from-gray-900/80 to-gray-950/80': 'gray',
}

const VALID = new Set(FRONTPAGE_COLORS.map((c) => c.id))

/** Resolve a stored color value to a known accent token. */
export function resolveFrontpageColor(raw, fallback = 'gray') {
  if (!raw) return fallback
  if (VALID.has(raw)) return raw
  if (LEGACY_COLOR_MAP[raw]) return LEGACY_COLOR_MAP[raw]
  // Soft match: "sky" substring in old gradient-ish strings
  for (const id of VALID) {
    if (typeof raw === 'string' && raw.includes(id)) return id
  }
  return fallback
}
